import { string, bool, func, shape, object } from 'prop-types';
import React, { Component } from 'react';
import SubHeaderSearch from '../../JobMatching/ResultDetails/SubHeaderSearch';
import DataCutsList from '../../Rules/EditRulePanel/DataCutsListPanel/DataCutsList/DataCutsList';
import NavListRow from 'ps-components/NavListRow/NavListRow';
import Search from 'ps-components/Search/Search';
import SlideoutHeader from 'ps-components/Slideout/Header/SlideoutHeader';
import SlideoutFooter from 'ps-components/Slideout/Footer/SlideoutFooter';
import SlideoutFooterStandardButtons from 'ps-components/Slideout/Footer/SlideoutFooterStandardButtons';
import SlideoutError from 'ps-components/Slideout/Error/SlideoutError';
import './DataCutPrioritySlideoutPanel.scss';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as ReviewDataCutsActions from '../actions/ReviewDataCutsActions';
import LoadingIndicator from 'ps-components/LoadingIndicator/LoadingIndicator';
import TruncatedString from 'ps-components/TruncatedString/TruncatedString';
import { CONTACT_SUPPORT_MESSAGE } from '../../../lib/constants';

export class DataCutPrioritySlideoutPanel extends React.Component {
  static propTypes = {
    searchSurveyText: string,
    searchDataCutText: string,
    selectedSurveyCode: string,
    backText: string,
    surveys: object,
    goBack: func
  };

  static defaultProps = {
    backText: 'Return',
    slideout: {
      slideoutProps: {}
    },
    surveys: []
  };

  constructor(props) {
    super(props);
    this.changeSelectedDataCutsTab = this.changeSelectedDataCutsTab.bind(this);
    this.renderBodyDataCutsPagination = this.renderBodyDataCutsPagination.bind(this);
    this.state = { showSelectedDataCutsTab: false };
  }

  changeSelectedDataCutsTab() {
    this.setState({ showSelectedDataCutsTab: !this.state.showSelectedDataCutsTab });
  }

  isDataCutSelected(dataCut) {
    return dataCut.job_scope_checked;
  }

  getDataCutId(dataCut) {
    return dataCut.unique_identifier;
  }

  getDataCutName(dataCut) {
    const nameComponent = dataCut.job_scope_checked ? (
      <div className="datacut__data--selected">{dataCut.job_scope}</div>
    ) : (
      dataCut.job_scope
    );

    const defaultComponent = true ? <div className="datacut__data--default">Default</div> : null;

    return (
      <React.Fragment>
        {nameComponent}
        {defaultComponent}
      </React.Fragment>
    );
  }

  getDataCutCurrency(dataCut) {
    return dataCut.currency;
  }

  getDataCutPriority(dataCut) {
    return dataCut.priority_level;
  }

  renderError = props => {
    if (!props.hasError) return;

    return (
      <SlideoutError className="survey-migration-review-data-cuts__error" doClose={props.closeError}>
        <h4>An error has occurred. Recent changes may have been lost.</h4>
        <div className="survey-migration-review-data-cuts-error__instructions">
          {CONTACT_SUPPORT_MESSAGE}
        </div>
      </SlideoutError>
    );
  };

  renderHeader = props => {
    return (
      <SlideoutHeader
        title="Review Data Cut Priority"
        subtitle={
          <a className="survey-migration-review-data-cuts__back" onClick={props.goBack}>
            <i className="icon-reply icon-reverse" />
            {props.backText}
          </a>
        }
        doClose={props.slideout.slideoutProps.hideSlideout}
      />
    );
  };

  renderBody = props => {
    return (
      <div className="survey-migration-review-data-cuts__body">
        {this.renderError(props)}
        <LoadingIndicator loading={props.loading} />
        {this.renderBodySurveyList(props)}
        {this.renderBodyDataCuts(props)}
      </div>
    );
  };

  renderBodySurveyList = props => {
    const { surveys, loadingSurveys } = props;
    return (
      <section className="survey-migration-review-data-cuts__survey-list">
        <Search
          className="survey-migration-review-data-cuts-survey-list__search"
          onChange={props.searchSurveys}
          onClick={props.clearSearchSurveys}
          placeholder="Search for Survey"
          value={props.searchSurveyText}
        />
        <LoadingIndicator className="survey-migration-review-data-cuts__right-panel" loading={loadingSurveys}>
          <div className="survey-migration-review-data-cuts-survey-list__body">
            {surveys.map(s => {
              const isSelected = props.selectedSurveyCode === s.survey_code;
              const rowClassName = classNames({
                ['survey-migration-review-data-cuts-survey-list__row']: true,
                ['survey-migration-review-data-cuts-survey-list__row--selected']: isSelected
              });

              return (
                <NavListRow
                  key={`survey-list-key-${s.survey_code}`}
                  className={rowClassName}
                  isSelected={isSelected}
                  onClick={() => props.selectSurvey(s.survey_code)}
                >
                  <div className="survey-migration-review-data-cuts-survey-list-row__survey">{s.survey_code}</div>
                  <div>{s.pub_survey_short_name}</div>
                </NavListRow>
              );
            })}
          </div>
        </LoadingIndicator>
      </section>
    );
  };

  renderBodyDataCuts = props => {
    const {
      surveys,
      selectedSurveyCode,
      selectedSurveyDataCuts,
      loadingDataCuts,
      updateDataCutSelection,
      updateDataCutPriority
    } = props;

    const { showSelectedDataCutsTab } = this.state;
    if (!selectedSurveyCode) return null;

    const selectedSurvey = surveys.find(s => s.survey_code === selectedSurveyCode);
    if (!selectedSurvey) return null;

    return (
      <section className="survey-migration-review-data-cuts__right-panel">
        <div className="survey-migration-settings-right-panel__survey-code">{selectedSurvey.survey_code}</div>
        <div className="survey-migration-settings-right-panel__survey-name">
          <TruncatedString maxChar={70}>{selectedSurvey.pub_survey_short_name}</TruncatedString>
        </div>
        <SubHeaderSearch
          isSelected={!showSelectedDataCutsTab}
          placeholderText=""
          searchId="datacuts__search"
          searchByText={() => console.log('implement search by text')}
          searchText={props.searchDataCutText}
          selectedItems={selectedSurveyDataCuts.filter(d => this.isDataCutSelected(d))}
          setSearchText={props.searchDataCuts}
          clearSearch={props.clearSearchDataCuts}
          toggleSelected={this.changeSelectedDataCutsTab}
          totalCount={selectedSurveyDataCuts.length}
        />
        <LoadingIndicator loading={loadingDataCuts}>
          <DataCutsList
            className="survey-migration-review-data-cuts__cut-list"
            isSelected={showSelectedDataCutsTab}
            updateDataCutSelection={updateDataCutSelection}
            updateDataCutPriority={updateDataCutPriority}
            dataCuts={
              !showSelectedDataCutsTab
                ? selectedSurveyDataCuts
                : selectedSurveyDataCuts.filter(d => this.isDataCutSelected(d))
            }
            getDataCutPriority={this.getDataCutPriority}
            getDataCutName={this.getDataCutName}
            getDataCutCurrency={this.getDataCutCurrency}
            getDataCutId={this.getDataCutId}
            isDataCutSelected={this.isDataCutSelected}
            renderPagination={this.renderBodyDataCutsPagination}
          />
        </LoadingIndicator>
      </section>
    );
  };

  renderBodyDataCutsPagination = () => {
    return null;
  };

  renderFooter = props => {
    return (
      <SlideoutFooter isBoxShadowTheme={true}>
        <SlideoutFooterStandardButtons applyText="Done" showCancel={false} doApply={props.goBack} />
      </SlideoutFooter>
    );
  };

  render() {
    return (
      <div className="survey-migration-review-data-cuts">
        {this.renderHeader(this.props)}
        {this.renderBody(this.props)}
        {this.renderFooter(this.props)}
      </div>
    );
  }
}

const mapStateToProps = ({ surveyMigration }) => {
  return {
    ...surveyMigration.reviewDataCuts
  };
};

const actions = {
  ...ReviewDataCutsActions
};

export default connect(mapStateToProps, actions)(withRouter(DataCutPrioritySlideoutPanel));
